import { FC } from "react";
import "../../../styles/Home/Benefits/Benefits.css"
import { BenefitItem } from "./BenefitItem";
import { useIntl } from "react-intl";

const Benefits: FC = () => {
    const intl = useIntl()
    
    return (
        <div className="container-fluid bg-benefits px-5 container-vertical-padding sora">
            <h1 className="fw-bold" dangerouslySetInnerHTML={{__html: intl.formatMessage({ id: "BENEFIT.HEADER" })}} ></h1>
            <div className="row mt-5 pb-md-0 mx-lg-5 px-md-4 pb-4 mb-4">
                <div className="col-6 col-md-4 mb-4">
                    <BenefitItem benefit="benefit-1" title={ intl.formatMessage({ id: "BENEFIT.TITLE1" }) }  />
                </div>
                <div className="col-6 col-md-4 mb-4">
                    <BenefitItem benefit="benefit-2" title={ intl.formatMessage({ id: "BENEFIT.TITLE2" }) } />
                </div>
                <div className="col-6 col-md-4 mb-4">
                    <BenefitItem benefit="benefit-3" title={ intl.formatMessage({ id: "BENEFIT.TITLE3" }) } />
                </div>
                <div className="col-6 col-md-4 mb-4">
                    <BenefitItem benefit="benefit-4" title={ intl.formatMessage({ id: "BENEFIT.TITLE4" }) } />
                </div>
                <div className="col-6 col-md-4 mb-4">
                    <BenefitItem benefit="benefit-5" title={ intl.formatMessage({ id: "BENEFIT.TITLE5" }) } />
                </div>
                <div className="col-6 col-md-4">
                    <BenefitItem benefit="benefit-6" title={ intl.formatMessage({ id: "BENEFIT.TITLE6" }) } />
                </div>
            </div>
        </div>
    )
}

export { Benefits };